import React from "react";
import styles from "./VoiceAssistant.module.scss";

const VoiceAssistant = ({ status = "idle", triggerRef, onToggle }) => {
  return (
    <div className={styles.voiceAssistantWrapper} onClick={onToggle} ref={triggerRef} title="Hanshi AI">
      <div className={`${styles.voiceOrb} ${styles[status] || ""}`}>
        <div className={styles.orbCore}></div>
        <div className={styles.orbRing}></div>
        <div className={styles.orbRing2}></div>
      </div>
    </div>
  );
};

export default VoiceAssistant;
